<template>
  <el-row v-loading="loading">
    <el-col :span="6">
      <div id="ap-all" style="height: 400px;width: 100%;" @click="$router.push('/ap/list')" />
    </el-col>
    <el-col :span="6">
      <div id="ap-online" style="height: 400px;width: 100%;" @click="$router.push('/ap/list?status=3')" />
    </el-col>
    <el-col :span="6">
      <div id="ap-unactivated" style="height: 400px;width: 100%;" @click="$router.push('/ap/list?status=1')" />
    </el-col>
    <el-col :span="6">
      <div id="ap-arrearage" style="height: 400px;width: 100%;" @click="$router.push('/ap/list?status=4')" />
    </el-col>
  </el-row>
</template>

<script>
import { debounce } from '@/utils/common'
import { apHomeStatusApi } from '@/api/ap/apApi'

export default {
  data() {
    return {
      loading: false,
      chart1: null,
      chart2: null,
      chart3: null,
      chart4: null,
      total_num: 0,
      online_num: 0,
      expired: 0,
      inactive: 0,
      chart1Option: {
        color: ['#59ADF3'],
        tooltip: {
          formatter: '{a} : {c} 个 ({d} %)'
        },
        series: [{
          name: '所有接入点',
          type: 'pie',
          radius: [90, 100],
          label: {
            position: 'center'
          },
          data: [{
            value: 0,
            name: '所有',
            label: {
              formatter: '{c}',
              textStyle: {
                fontSize: 42
              }
            }
          }, {
            value: 0,
            name: '其他',
            label: {
              formatter: '\n所有',
              textStyle: {
                color: '#9a9a9a',
                fontSize: 16
              }
            },
            tooltip: {
              show: false
            },
            itemStyle: {
              color: '#ddd'
            },
            hoverAnimation: false
          }]
        }]
      },
      chart2Option: {
        color: ['#07c160'],
        tooltip: {
          formatter: '{a} : {c} 个 ({d} %)'
        },
        series: [{
          name: '在线接入点',
          type: 'pie',
          radius: [90, 100],
          label: {
            position: 'center'
          },
          data: [{
            value: 0,
            name: '在线',
            label: {
              formatter: '{c}',
              textStyle: {
                fontSize: 42
              }
            }
          }, {
            value: 0,
            name: '不在线',
            label: {
              formatter: '\n在线',
              textStyle: {
                color: '#9a9a9a',
                fontSize: 16
              }
            },
            tooltip: {
              show: false
            },
            itemStyle: {
              color: '#ddd'
            },
            hoverAnimation: false
          }]
        }]
      },
      chart3Option: {
        color: ['#9f9f9f'],
        tooltip: {
          formatter: '{a} : {c} 个 ({d} %)'
        },
        series: [{
          name: '未激活接入点',
          type: 'pie',
          radius: [90, 100],
          label: {
            position: 'center'
          },
          data: [{
            value: 0,
            name: '未激活',
            label: {
              formatter: '{c}',
              textStyle: {
                fontSize: 42
              }
            }
          }, {
            value: 0,
            name: '已激活',
            label: {
              formatter: '\n未激活',
              textStyle: {
                color: '#999',
                fontSize: 16
              }
            },
            tooltip: {
              show: false
            },
            itemStyle: {
              color: '#ddd'
            },
            hoverAnimation: false
          }]
        }]
      },
      chart4Option: {
        color: ['#e64340'],
        tooltip: {
          formatter: '{a} : {c} 个 ({d} %)'
        },
        series: [{
          name: '欠费接入点',
          type: 'pie',
          radius: [90, 100],
          label: {
            position: 'center'
          },
          data: [{
            value: 0,
            name: '待续费',
            label: {
              formatter: '{c}',
              textStyle: {
                fontSize: 42
              }
            }
          }, {
            value: 0,
            name: '正常',
            label: {
              formatter: '\n待续费',
              textStyle: {
                color: '#9a9a9a',
                fontSize: 16
              }
            },
            tooltip: {
              show: false
            },
            itemStyle: {
              color: '#ddd'
            },
            hoverAnimation: false
          }]
        }]
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.initChart()
    this.__resizeHandler = debounce(() => {
      if (this.chart1) {
        this.chart1.resize()
      }
      if (this.chart2) {
        this.chart2.resize()
      }
      if (this.chart3) {
        this.chart3.resize()
      }
      if (this.chart4) {
        this.chart4.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },
  methods: {
    fetchData() {
      this.loading = true
      apHomeStatusApi().then(res => {
        this.loading = false
        if (!res.errno) {
          this.total_num = res.data.total
          this.online_num = res.data.online
          this.expired = res.data.expired
          this.inactive = res.data.inactive
          this.setChart1()
          this.setChart2()
          this.setChart3()
          this.setChart4()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    setChart1() {
      this.chart1Option.series[0].data[0].value = this.total_num
      this.chart1.setOption(this.chart1Option)
    },
    setChart2() {
      this.chart2Option.series[0].data[0].value = this.online_num
      this.chart2Option.series[0].data[1].value = this.total_num - this.online_num
      this.chart2.setOption(this.chart2Option)
    },
    setChart3() {
      this.chart3Option.series[0].data[0].value = this.inactive
      this.chart3Option.series[0].data[1].value = this.total_num - this.inactive
      this.chart3.setOption(this.chart3Option)
    },
    setChart4() {
      this.chart4Option.series[0].data[0].value = this.expired
      this.chart4Option.series[0].data[1].value = this.total_num - this.expired
      this.chart4.setOption(this.chart4Option)
    },
    initChart() {
      this.chart1 = this.$echarts.init(document.getElementById('ap-all'), 'teenager')
      this.chart2 = this.$echarts.init(document.getElementById('ap-online'), 'teenager')
      this.chart3 = this.$echarts.init(document.getElementById('ap-unactivated'), 'teenager')
      this.chart4 = this.$echarts.init(document.getElementById('ap-arrearage'), 'teenager')
      this.chart1.setOption(this.chart1Option)
      this.chart2.setOption(this.chart2Option)
      this.chart3.setOption(this.chart3Option)
      this.chart4.setOption(this.chart4Option)
    }
  }
}
</script>
